import { SERVICES_AN_ERROR_OCCURRED_LOADING } from 'common/constants/services/services';

// Documents By Id
export const DOCUMENTS_BY_ID_QUERY_KEY = 'DOCUMENTS_BY_ID';
export const DOCUMENTS_BY_ID_TITLE = 'Document Previews';
export const DOCUMENTS_BY_ID_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(DOCUMENTS_BY_ID_TITLE);
export const DOCUMENTS_BY_ID_STALE_TIME = 5 * 60 * 1000; // 5 minutes
